<div class="main">
    <!-- Header -->
    <div class="header" (click)="openSprintcard($event)" [ngClass]="{'editable': !(sprint.state === 'closed')}">
        <div class="first-line">
            <div class="sprint-name">
                <span>{{sprint.name}}</span>
            </div>
            <div class="sprint-points">
                <span>{{sprint['sumOfStorypointsDone']}}/{{sprint['sumOfStorypoints']}}</span>
            </div>
        </div>

        <div class="second-line">
            <div class="sprint-dates">
                {{sprint.startDate | date: 'dd.MM.yy'}} - {{sprint.endDate | date: 'dd.MM.yy'}}
            </div>
        </div>
    </div>

    <!-- Issuelist -->
    <div cdkDropList class="issue-list"
        [cdkDropListData]="issues" 
        [attr.data-sprintname]="sprint.name"
        [attr.data-sprintid]="sprint.id"
        [cdkDropListDisabled]="sprint.state === 'closed'"
        (cdkDropListDropped)="onIssueDropped($event)"
    >   
        <app-issue *ngFor="let issue of issues" 
            class="issue-list-element teamwidgetdropzone imagedropzone whiteboarddropzone"
            cdkDrag
            [ngClass]="{
                'parent-issue': (!issue.isSubissue), 
                'sub-issue': (issue.isSubissue)
            }"
            [issue]="issue"
            [projectKey]="projectKey"
            [statuses]="statuses"
            [inheritedIssueType]="issue.issueType"
            [attr.data-highlightcolor]="issue.highlightColor"
            [attr.data-issueid]="issue.id"
            [attr.data-projectkey]="projectKey"
            [cdkDragData]="issue"
            (cdkDragMoved)="onCardMoved($event)"
            (issueModified)="onIssueModified()"
            (issueRemoved)="onIssueRemoved($event)"
        >
        </app-issue>
    </div>
    <!-- Footer -->
    <div class="footer">
        <!-- 'Start Sprint' -->
        <a class="sprint-state-option" *ngIf="(sprint.state === 'future') && sprint.startDate && sprint.endDate" 
            (click)="startSprint(sprint)">{{('actionview.releaseplanning.startableSprint' | translate)}}
        </a>
        <!-- 'Finish Sprint' -->
        <a class="sprint-state-option" *ngIf="(sprint.state === 'active')" [disabled]="!sprint.allIssuesDone" 
            (click)="finishSprint(sprint)">{{('actionview.releaseplanning.finishSprint' | translate)}}
        </a>
        <!-- Closed/Future Sprint -->
        <a class="sprint-state-option disabled"
            *ngIf="(sprint.state === 'closed') || ((sprint.state === 'future') && (!sprint.startDate || !sprint.endDate))">
            <span *ngIf="(sprint.state === 'closed')">
                {{'actionview.releaseplanning.closedSprint' | translate}}
            </span>
            <span *ngIf="(sprint.state === 'future') && (!sprint.startDate || !sprint.endDate)">
                {{'actionview.releaseplanning.futureSprint' | translate}}
            </span>
        </a>
    </div>

</div>

